import { gql } from "@apollo/client";

export const GRAPHIC_LIST_CREATE = gql`
  mutation GraphicListCreate($input: GraphicListFieldsInput!) {
    graphicListCreate(input: $input) {
      label
      message
      graphicList {
        id
        title
        status
        start_build_at
        start_event_at
        stands_count
        creator_id
        created_at
        updated_at
      }
    }
  }
`;

export const GRAPHIC_LIST_UPDATE = gql`
  mutation GraphicListUpdate($input: GraphicListFieldsInput!) {
    graphicListUpdate(input: $input) {
      label
      message
      graphicList {
        id
        title
        status
        start_build_at
        start_event_at
        stands_count
        creator_id
        created_at
        updated_at
      }
    }
  }
`;

export const GRAPHIC_LIST_DELETE = gql`
  mutation GraphicListDelete($id: ID!) {
    graphicListDelete(id: $id) {
      label
      message
    }
  }
`;